import type { RenderLayerProps } from 'react-laag';
import { Arrow } from 'react-laag';
import { Scrollbar } from 'react-scrollbars-custom';

import { IInlineSelectProps } from '../types';
import styles from './index.module.css';

type Props = {
  minWidth: number;
  options: IInlineSelectProps['options'];
  onChange: IInlineSelectProps['onChange'];
} & RenderLayerProps;

const OPTION_ITEM_HEIGHT = 25;
const OPTION_CONTAINER_MAX_HEIGHT = 110;
const OPTION_CONTAINER_VERTICAL_INDENT_SUM = 10;

export function LegacyVariant(props: Props) {
  const { isOpen, layerProps, arrowStyle, layerSide, close, minWidth, options, onChange } = props;

  if (!isOpen) return null;

  return (
    <div
      ref={layerProps.ref}
      className="layer"
      style={{
        ...layerProps.style,
        zIndex: '9',
        minWidth,
      }}
    >
      <Scrollbar
        noScrollX
        style={{
          height:
            options.length >= 4
              ? OPTION_CONTAINER_MAX_HEIGHT
              : options.length * OPTION_ITEM_HEIGHT + OPTION_CONTAINER_VERTICAL_INDENT_SUM,
        }}
        trackYProps={{
          style: { width: 2, right: 4, background: 'none', boxShadow: 'inset #c4c4c4 0px 0px 0px 0.25px' },
        }}
        thumbYProps={{ style: { background: '#c4c4c4' } }}
        contentProps={{ style: { padding: 0 } }}
        className={styles.optionsContainer}
      >
        {options.map((option) => (
          <button
            key={option.value}
            className={styles.optionItem}
            type="button"
            onClick={() => {
              onChange && onChange(option.value!);
              close();
            }}
          >
            {option.label}
          </button>
        ))}
      </Scrollbar>

      <Arrow
        style={{ ...arrowStyle, zIndex: '9' }}
        layerSide={layerSide}
        borderWidth={1}
        borderColor="rgba(0, 0, 0, 0.04)"
        backgroundColor="#fff"
        angle={40}
        roundness={0.5}
        size={12}
      />
    </div>
  );
}
